import { parseToBRL } from '@grupoboticario/barril-del-chavo'
import { Box, Card, Flex, FloraButton, FloraTypography } from '@grupoboticario/flora-react'
import { EyeIcon } from '@grupoboticario/flora-react-icons'
import { useEffect, useState } from 'react'
import { IProduct } from 'src/@interfaces'
import { useGetProductsBySkus } from 'src/hooks'

export interface VideoProductCardProps {
  productSku: string
  onClickProductDetails?: (productSku: string) => void
}

export const VideoProductCard = ({ productSku, onClickProductDetails }: VideoProductCardProps) => {
  const [product, setProduct] = useState<IProduct>()
  const getProduct = useGetProductsBySkus()

  useEffect(() => {
    const fetchProduct = async () => {
      getProduct([productSku]).then((fetchedProducts) => {
        if (fetchedProducts.data?.products && fetchedProducts.data?.products?.length > 0) {
          setProduct(fetchedProducts.data.products[0])
        }
      })
    }
    fetchProduct()
  }, [productSku, getProduct])

  const handleProductDetailButtonClick = () => {
    onClickProductDetails?.(productSku)
  }

  return product ? (
    <Card
      css={{
        position: 'absolute',
        bottom: '$4',
        left: '$4',
        right: '$4',
        zIndex: '$dropdown',
        opacity: 0.8,
        cursor: 'pointer',
      }}
      onClick={handleProductDetailButtonClick}
      data-testid="product-card"
    >
      <Flex
        gap="$3"
        justify="space-between"
      >
        <Box>
          <FloraTypography fontSize="bodySmallStandard">{product?.name}</FloraTypography>
          <FloraTypography
            fontSize="bodySmallShort"
            fontWeight="bold"
            css={{ marginTop: '$1' }}
          >
            por {parseToBRL(product?.salePrice)}
          </FloraTypography>
        </Box>
        <Box css={{ alignContent: 'center' }}>
          <FloraButton
            hierarchy="primary"
            size="medium"
            has="iconRight"
            icon={<EyeIcon />}
            isFull
            styleSemantic="conversion"
            onClick={handleProductDetailButtonClick}
          >
            Ver detalhes
          </FloraButton>
        </Box>
      </Flex>
    </Card>
  ) : null
}
